export default "__VITE_ASSET__39_OlriA__"